// extracted by mini-css-extract-plugin
export var modalFooter = "_mw-0";